import _get from 'lodash/get';
import _omitBy from 'lodash/omitBy';
import { TrackingParams } from '../types/AnalyticsTracking';

export const PATHNAME_REGEX = {
  OLDPDP: /^\/product-landing/i,
  PDP: /^\/pdp\/([^/]+)/i,
  BRANDCLUB: /^\/(brandclub)/i,
  BRAND: /^\/(brand)/i,
};

export const PATHNAME_CHECKER = {
  isOldPDP: (pathname: string) => (pathname ? PATHNAME_REGEX.OLDPDP.exec(pathname) : false),
  isPDP: (pathname: string) => (pathname ? PATHNAME_REGEX.PDP.exec(pathname) : false),
  isBrandPage: (pathname: string) => (pathname ? PATHNAME_REGEX.BRAND.exec(pathname) : false),
  isBrandclubPage: (pathname: string) => (pathname ? PATHNAME_REGEX.BRANDCLUB.exec(pathname) : false),
};

export const copyTrackingParamsToUrlSearchParams = (
  trackingParams: Partial<TrackingParams>,
  urlSearchParams = new URLSearchParams(),
) => {
  Object.entries(trackingParams).forEach((c) => {
    const key = c[0];
    const val = c[1];

    if (key && val !== undefined) {
      urlSearchParams.set(key, val + '');
    }
  }, {} as { [k: string]: string | string[] });
  return urlSearchParams;
};
